import Image from "next/image";

export const ImageViewer = ({
  mediaURL,
  gameTitle,
  handleCloseMedia,
  isMediaOpen,
}: {
  mediaURL: string;
  gameTitle?: string;
  handleCloseMedia: () => void;
  isMediaOpen: boolean;
}) => {
  if (!isMediaOpen) return null;

  return (
    <button
      type="button"
      onClick={handleCloseMedia}
      className="relative w-screen h-dvh"
    >
      {/* Blurred media */}
      <Image
        src={mediaURL}
        alt={`${gameTitle ?? "Game"} Art`}
        fill
        className="object-fill blur-xl brightness-50"
        sizes="(max-width: 640px) 100vw, 92vw"
      />

      <Image
        src={mediaURL}
        alt={`${gameTitle ?? "Game"} Art`}
        fill
        className="object-contain"
        sizes="(max-width: 640px) 100vw, 92vw"
      />
    </button>
  );
};
